/*
 * 文件EN: riskScreen.js,
 * 文件CN: 风控云台,
 * 创建时间: Monday, 1st June 2020 3:29:35 pm,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */

import * as Models from '@/api/T3/riskScreen'

export default {
  namespaced: true,
  actions: {
    // 交易数据统计
    getEcharts(ctx, payload) {
      return Models.fetchEcharts(payload).then(res => {
        return res && res.status === 200 ? res.data : null
      })
    },
    // 风控巡查列表---交易要素和交易效验
    getTradingElements(ctx, payload) {
      return Models.selectTradingElements(payload).then(res => {
        return res && res.status === 200 ? res.data : null
      })
    },
    // 风控巡查列表---查询历史交易经纬度
    getCoordinate(ctx, payload) {
      return Models.selectCoordinate(payload).then(res => {
        return res && res.status === 200 ? res.data : null
      })
    },
    // 添加预设
    setAdvanceTradeFilter(ctx, payload) {
      return Models.saveAdvanceTradeFilter(payload).then(res => {
        return res && res.status === 200
      })
    },
    // 查询预设交易过滤
    getAdvanceTradeFilter(ctx, payload) {
      return Models.getAdvanceTradeFilter(payload).then(res => {
        return res && res.status === 200 ? res.data : null
      })
    },
    // 风控巡查列表---历史被管控对象
    getHistoryControlled(ctx, payload) {
      return Models.historyControlled(payload).then(res => {
        return res && res.status === 200 ? res.data : null
      })
    },
    // 添加介入风控记录 
    postInterventionRisk(ctx, payload) {
      return new Promise((resolve, reject) => {
        Models.interventionRisk(payload).then(res => {
          res && res.status === 200 ? resolve() : reject()
        })
      })
    },
  }
}